<template>
    <div class="itemHolder">

        <div class="row" :key="key" v-for="(item, key) of teamCarriers">
            <div class="title textNoWrap">{{ getItem(item) }}</div>
            <div class="removeBtn"><button class="remove" @click="remove(key)"><i class="fas fa-trash"></i></button></div>
        </div>

        <form class="itemForm" action="" @submit.prevent="addItem">
            <select v-model="selectedItem">
                <option value="">-- Select carrier --</option>
                <option :key="key" v-for="(item, key) of excludedCarriers" :value="key">{{ item.name }}</option>
            </select>
            <button class="default" type="submit" :disabled="!isValidForm"><i class="fas fa-plus"></i></button>
        </form>
        
    </div>
</template>

<script>
import { mapGetters } from "vuex";
    export default {
        props: ["modelValue"],
        data() {
            return {
                teamCarriers: this.modelValue || [],
                selectedItem: ''
            };
        },
        computed: {
            ...mapGetters(["carriers"]),
            isValidForm() {
                return this.carriers[this.selectedItem];
            },
            excludedCarriers() {
                return this.carriers.filter(carrier => {
                    for(const item of this.teamCarriers) {
                        if(carrier._id == item) return false;
                    }
                    return true;
                });
            }
        },
        methods: {
            remove(key) {
                this.teamCarriers.splice(key, 1);
                this.selectedItem = '';
            },
            addItem() {
                this.teamCarriers.push(this.excludedCarriers[this.selectedItem]._id);
                this.selectedItem = '';
            },
            getItem(id) {
                for(const item of this.carriers) {
                    if(item._id == id) return item.name;
                }
                return 'Unknown';
            }
        },
        mounted() {
            this.$emit("update:modelValue", this.teamCarriers);
        },
    };
</script>

<style lang="scss" scoped>

.itemHolder {
    border: 1px solid $borderColor;
    border-radius: $borderRadius;
    background: $bgSecondary;
}

.itemForm {
    display: grid;
    grid-template-columns: minmax(0, 1fr) 40px;
    column-gap: 20px;
    grid-template-rows: 40px;
    padding: 10px 20px;
    border-top: 1px solid $borderColor;
    &:first-child {
        border: 0;
    }
    select, input {
        width: 100%;
        text-align: center;
        background: transparent;
        border: 0;
        padding: 0 10px;
    }
    select {
        text-align: left;
    }
    button {
        padding: 0;
        height: auto;
    }
}



.row {
    display: grid;
    height: 50px;
    align-items: center;
    padding: 0 20px;
    grid-template-columns: minmax(0, 1fr) 20px;
    column-gap: 20px;

    &:nth-child(2n) {
        background: $bg;
    }
    .title {
        font-weight: bold;
    }
    .value {
        text-align: right;
    }
    .removeBtn {
        width: 20px;
        height: 20px;
        .remove {
            width: inherit;
            height: inherit;
            background: transparent;
            border: 0;
            font-size: 10px;
            color: $error;
        }
    }
}
</style>